export interface ForgotPasswordModel {
  email: string
}

export const ForgotPasswordInitValues: ForgotPasswordModel = {
  email: '',
}
